<template>
  <div
    class="grey-box"
    :class="wrappClass"
  >
    <slot />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  export default defineNuxtComponent({
    name: 'GreyBox',

    provide() {
      return {
        eventAction: () => 'Серый блок',
      };
    },

    inject: {
      area: {
        default() {
          return () => '';
        },
      },

      areaAnalytics: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      title: {
        type: String as PropType<string>,
        default: null,
      },

      // widget visibility, consume so it does not appear in html
      visibility: {
        type: Object as PropType<any>,
        default: null,
      },
    },

    computed: {
      getArea(): string {
        // @ts-expect-error injected functions are not typed in options API
        if (this.area) {
          // @ts-expect-error injected functions are not typed in options API
          return this.area();
        }
        return '';
      },

      wrappClass(): Record<string, boolean> {
        const areas: Array<string> = [
          'above-comments',
          'below-comments',
          'home',
          'after-first-paragraph',
          'post-dynamic',
        ];

        return {
          [`grey-box--${this.getArea}`]: areas.includes(this.getArea),
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .grey-box {
    $grey-box: &;
    position: relative;
    padding: $spacing-6 $spacing-4;
    font-family: $text-font--1;
    border: 1px solid $stroke-color--1;
    border-radius: 32px;
    background: #fbf8f8;
    color: $text-color--2;
    @include smallText;

    @include tablet {
      @include normalText;
      padding: $spacing-6;
    }

    .article-page & {
      margin-bottom: 24px;
    }

    &--above-comments,
    &--below-comments,
    &--after-first-paragraph,
    &--home,
    &--post-dynamic {
      margin: 0 auto;

      @include tablet {
        padding: $spacing-6;
      }
    }

    &--home {
      margin: 0 $spacing-4;
      padding: $spacing-6 $spacing-4;
      @include tablet {
        max-width: 828px;
        margin: 0;
        padding: $spacing-6;
      }

      @include big-tablet {
        padding: $spacing-6 $spacing-8;
      }

      @include desktop {
        padding: $spacing-6 $spacing-10;
      }
    }

    .infoblock & {
      margin-bottom: 16px;
    }

    :deep() > div > div > strong {
      display: block;
      font-weight: 500;
      margin-bottom: 2px;
    }

    :deep() > div > div > strong + div strong {
      font-weight: 500;
    }

    :deep() a {
      @include link-styles;
    }
  }
</style>
